import React from 'react'

function LocationListItem({location, requestLocation}) {
    const {name, logo, text, status, hover, toggleHover} = location
    
    return (
        <li 
            className={`
                mapSide_locationList_location
                mapMarker-${status}
                ${hover ? 'mapSide_locationList_location-hover' : ''}
            `}
            onMouseEnter={() => toggleHover(name)}
            onMouseLeave={() => toggleHover(name)}
            onClick={() => requestLocation(name, status)}
        >
            <i className={logo}></i>
            <p>{text}</p>
        </li>
    )
}

export default LocationListItem